import classNames from 'classnames';
import styles from './Checkbox.module.scss';
import { ReactComponent as Check } from '../../../assets/check.svg';
import { useFade } from '..';

interface CheckboxProps {
  checked: boolean;
  disabled?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  id?: string;
  label?: string;
  variant?: 'checkbox before' | 'checkbox after';
}

export default function Checkbox({
  checked,
  disabled,
  onChange,
  id,
  label,
  variant = 'checkbox before',
}: CheckboxProps): JSX.Element {
  const [isVisible, , setShow, fadeProps] = useFade(checked);

  return (
    <label
      className={classNames(
        styles.root,
        disabled && styles.disabled,
        variant === 'checkbox after' && styles.checkboxAfter
      )}
    >
      <input
        className={styles.input}
        type='checkbox'
        id={`checkbox-${id}`}
        checked={checked}
        disabled={disabled}
        onChange={e => {
          onChange(e);
          setShow(!isVisible);
        }}
      />
      <span className={styles.check}>
        {isVisible && (
          <Check
            className={styles.checkIcon}
            {...fadeProps}
          />
        )}
      </span>
      {label}
    </label>
  );
}
